// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4277) return "static/chunks/4277-b4ebc3b2b18cc0d8.js";
	if (chunkId === 2294) return "static/chunks/2294-d3130ebfac896e4a.js";
	if (chunkId === 2565) return "static/chunks/2565-1131ca70fdae5261.js";
	if (chunkId === 7837) return "static/chunks/7837-d8e87598743a4eed.js";
	if (chunkId === 3063) return "static/chunks/3063-25c726ef4af84a2d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7753 ? "fc2f6fa8" : chunkId) + "." + {"3899":"ff251f5a3a20a3f1","6645":"879abb690f964b56","7576":"067d4d8076ac41e7","7753":"5fc16b590d1f7cbc","8742":"7607805d35041a2e","8865":"4222bbb0c34b291f"}[chunkId] + ".js";
};